import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Dialog, DialogTitle, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import { useState } from "react";
import { CloseIcon } from "../../../../components/Icon";

import UTC2Local, { formatDateTimeToStringV2 } from "../../../../UTC2Local";
import PaperComponent from "../../../../components/Modal/PaperComponent";

import LongText from "../../../../components/Text/LongText";
import { Subtitle } from "../../../../components/Titles/FormTitles";

import TimeEntriesList from "../../../admin-configuration/TimeEntries/TimeEntries-list";
import "./stye.css";

export function SimpleEmployeeTimesheetTable({
	t,
	data,
	handleOpenModal,
	generateTaskRoute,
	resourceGuid,
}) {
	const { dateSummaries, taskSummaries, totalDuration } = data;
	const displayDateDetailsCells = () => {
		const dateDetailsCells = [];
		for (let i = 0; i < 1; i++) {
			dateDetailsCells.push(
				<TableCell
					key={`empty-date-${i}`}
					align="left"
					sx={{
						left: 0,
						position: "sticky",
						backgroundColor: "#fff",
						zIndex: "10",
					}}
				>
					Total
				</TableCell>
			);
		}

		dateSummaries.forEach((row, index) => {
			dateDetailsCells.push(
				<TableCell
					key={`key-${index}`}
					align="right"
					sx={{
						width: "20%",
						fontWeight: "bold",
						paddingRight: "5px",
						paddingLeft: 0,
						top: 0,
						left: 0,
						position: "sticky",
						backgroundColor: "#fff",
						zIndex: "1",
					}}
				>
					{row?.totalDurationByDate}
				</TableCell>
			);
		});

		dateDetailsCells.push(
			<TableCell
				align="right"
				sx={{
					width: "20%",
					fontWeight: "bold",
					paddingRight: "5px",
					paddingLeft: 0,
					top: 0,
					left: 0,
					position: "sticky",
					backgroundColor: "#fff",
					zIndex: "1",
				}}
			>
				{totalDuration}
			</TableCell>
		);
		return dateDetailsCells;
	};
	const findTaskDurationForDate = (date, dateDetails) => {
		const matchingDate = dateDetails.find(
			(detail) => UTC2Local(detail.date, true) === UTC2Local(date, true)
		);
		return matchingDate
			? {
					billableDuration: matchingDate.billableDuration,
					nonBillableDuration: matchingDate.nonBillableDuration,
					totalDuration: matchingDate.totalDuration,
			  }
			: {
					billableDuration: "",
					nonBillableDuration: "",
					totalDuration: "",
			  };
	};
	const [openTimeEntriesModal, setOpenTimeEntriesModal] = useState(false);
	const [timeEntriesFilterData, setTimeEntriesFilterData] = useState(null);

	return (
		<>
			<Dialog
				PaperComponent={PaperComponent}
				open={openTimeEntriesModal}
				sx={{
					".MuiDialog-container .MuiPaper-root": {
						// maxWidth: "60% !important",
						minWidth: "60% !important",
					},
				}}
			>
				<DialogTitle
					style={{
						cursor: "move",
						borderBottom: "1px solid rgba(5, 5, 5, 0.06)",
					}}
					id="draggable-dialog-title"
				>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
						}}
					>
						<Subtitle
							style={{
								textAlign: "left",
								fontFamily: "poppins !important",
								fontSize: "16px",
								// paddingLeft: "35px",
							}}
						>
							{t("timesheet.drawer.title")}
						</Subtitle>
						<IconButton
							onClick={() => {
								setOpenTimeEntriesModal(false);
							}}
						>
							<CloseIcon color={"#9e9e9e"} width={"24"} stroke={"1.5"} />
						</IconButton>
					</div>
				</DialogTitle>
				<TimeEntriesList
					taskGuidFromReport={
						timeEntriesFilterData ? timeEntriesFilterData.taskGuid : null
					}
					projectGuidFromReport={
						timeEntriesFilterData
							? timeEntriesFilterData.projectGuid
							: null
					}
					resourceGuidFromReport={
						timeEntriesFilterData
							? timeEntriesFilterData.resourceGuid
							: null
					}
					selectedDateFromReport={
						timeEntriesFilterData ? timeEntriesFilterData.date : null
					}
				/>
			</Dialog>
			<TableContainer component={Paper} className={"table-timesheet-height"}>
				<Table
					id="employee-timesheet-table"
					sx={{ tableLayout: "fixed", width: "100%" }}
					stickyHeader
					size="small"
					aria-label="a dense table"
				>
					<TableHead>
						<TableRow>
							{/* <TableCell sx={{ minWidth: "auto", width: "300px" }}>
              {t("employeeTimesheet.project")}
            </TableCell> */}
							<TableCell
								sx={{
									textOverflow: "ellipsis",
									whiteSpace: "nowrap !important",
									overflow: "hidden",
									width: "20vw !important",
									minWidth: "auto",
									top: 0,
									left: 0,
									position: "sticky",
									backgroundColor: "#fff",
									zIndex: "3",
								}}
							>
								{t("employeeTimesheet.task")}
							</TableCell>
							{dateSummaries &&
								dateSummaries.map((date, index) => (
									<TableCell
										key={index}
										align="right"
										sx={{
											paddingLeft: 0,
											paddingRight: "5px",
											width: "70px",
											top: 0, // Ensure the top property is set to 0
											left: 0,
											position: "sticky",
											backgroundColor: "#fff",
											zIndex: "1", // Adjusted zIndex value
										}}
									>
										{formatDateTimeToStringV2(
											date?.date,
											false,
											true,
											null,
											false
										)}
									</TableCell>
								))}
							<TableCell
								align="right"
								sx={{
									paddingLeft: 0,
									paddingRight: "5px",
									width: "70px",
									top: 0, // Ensure the top property is set to 0
									left: 0,
									position: "sticky",
									backgroundColor: "#fff",
									zIndex: "1", // Adjusted zIndex value
								}}
							>
								{t("employeeTimesheet.total")}
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{taskSummaries &&
							taskSummaries.map((row, index) => {
								const { dateDetails } = row;
								const dateDetailsCells = [];

								dateSummaries.forEach((dateSummary) => {
									const {
										billableDuration,
										nonBillableDuration,
										totalDuration,
									} = findTaskDurationForDate(
										dateSummary?.date,
										dateDetails
									);
									dateDetailsCells.push(
										<TableCell
											key={dateSummary.date}
											align="right"
											sx={{
												paddingLeft: 0,
												paddingRight: "5px",
												top: 0, // Ensure the top property is set to 0
												left: 0,
												position: "sticky",
												backgroundColor: "#fff",
												zIndex: "1", // Adjusted zIndex value
											}}
											onClick={(event) => {
												console.log(
													dateSummary.date,
													row.taskGuid,
													resourceGuid
												);
												if (totalDuration !== "") {
													setTimeEntriesFilterData({
														date: dateSummary.date,
														taskGuid: row.taskGuid,
														resourceGuid: resourceGuid,
														projectGuid: row.projectGuid,
													});
													setOpenTimeEntriesModal(true);
												}
											}}
										>
											{" "}
											{totalDuration}
										</TableCell>
									);
								});

								dateDetailsCells.push(
									<TableCell
										key="total"
										align="right"
										sx={{
											fontWeight: "bold",
											paddingLeft: 0,
											paddingRight: "5px",
											top: 0, // Ensure the top property is set to 0
											left: 0,
											position: "sticky",
											backgroundColor: "#fff",
											zIndex: "1", // Adjusted zIndex value
										}}
									>
										{row?.totalTaskDuration}
									</TableCell>
								);

								return (
									<TableRow
										key={row?.taskGuid}
										sx={{
											"&:last-child td, &:last-child th": {
												border: 0,
											},
										}}
									>
										{/* <TableCell
                    component={Link}
                    align="left"
                    className="link-cell"
                    sx={{ paddingRight: 0 }}
                    to={generateProjectRoute(row)}
                    onClick={(event) => handleOpenModal(event, row)}
                  >
                    {LongText({ text: row.projectTitle, length: 48 })}
                  </TableCell> */}
										<TableCell
											component={Link}
											align="left"
											className="link-cell task"
											sx={{
												paddingRight: 0,
												left: 0,
												position: "sticky",
												left: 0,
												position: "sticky",
												backgroundColor: "#fff",
												textOverflow: "ellipsis",
												whiteSpace: "nowrap !important",
												overflow: "hidden",
												zIndex: "4", // Adjusted zIndex value
											}}
											to={generateTaskRoute(row)}
											onClick={(event) =>
												handleOpenModal(event, row)
											}
										>
											{LongText({
												text: `${row?.projectTitle} - ${row?.taskName}`,
												length: 70,
											})}
										</TableCell>
										{dateDetailsCells}
									</TableRow>
								);
							})}
						<TableRow>{displayDateDetailsCells()}</TableRow>
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
}
